import { TwcProduct } from '../../../twc-products';

export const GLOBAL_IR_SATELLITE_RADAR_PRODUCT_DATA: TwcProduct = {
  id: 'global-ir-satellite-radar',
  defaultProductId: 'sat-vis-boeing',
  productName: 'Weather-Sat-Visible-TWC',
  label: 'Global IR Satellite + Radar',
  weatherType: 'SAT_VIS',
  description: 'TWC product (raster) - Global Visible Satellite Imagery',
  series: 'Observation',
  timeSlicePeriodInMinutes: 60,
  lodMax: 7,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 85
};
